import { motion } from "framer-motion";
import React, { useEffect, useState, useMemo } from "react";
import Select from "react-select";
import * as GrIcons from "react-icons/gr";
import { useWizard } from "react-use-wizard";
import { toast } from "react-toastify";
import { makeGetRequest } from "../../services/apiHandler";
import { useDispatch, useSelector } from "react-redux";
import { stepActions } from "../../store/Steps";
import { getIndividualPayloadActions } from "../../store/IndividualPayload";
import { variants } from "../../shared/variants";
import { travelCurrentScreenActions } from "../../store/CurrentTravelScreen";
import makeAnimated from "react-select/animated";
import {
  onValidEmailAddress,
  onValidatePhoneNumber,
} from "../../services/app.services";
import { useMixpanelIdentify } from "../../services/mixpanel.service";
import { isStandardInurance } from "../../shared/currency-formatter/utils";
import { useTranslation } from "react-i18next";

const animatedComponents = makeAnimated();

function IndividualDetails({
  setCurrentScreen,
  individualStatus,
  groupStatus,
}: any) {
  const { t } = useTranslation();
  const individualPayload = useSelector(
    (state: any) => state.individualData.individual
  );

  const tenantCreds = useSelector((state: any) => state.tenantCreds);
  const isStandard = useMemo(() => isStandardInurance(tenantCreds?.domain), [tenantCreds?.domain]);

  const { mixpanelIdentify } = useMixpanelIdentify()

  const travel_option = sessionStorage.getItem("travel_option")!;
  const dispatch = useDispatch();

  const { previousStep, nextStep } = useWizard();

  const [userInfor, setUserInfor] = useState({
    userName: "",
    email: "",
    phoneNumber: "",
  });

  const [travelInfo, setTravelInfo] = useState({
    startDate: individualPayload?.startDate ? individualPayload?.startDate : "",
    endDate: individualPayload?.endDate ? individualPayload?.endDate : "",
    userName: "",
    phoneNumber: "",
    location: "",
    yearOfBirth: individualPayload?.yearOfBirth
      ? individualPayload?.yearOfBirth
      : "",
    reason: individualPayload?.reason ? individualPayload?.reason : "",
    departureCountry:
      travel_option == "inbound" || travel_option == "outbound" ? (isStandard ? "Ethiopia" : "Kenya") : "",
    destinationCountry:
      travel_option == "inbound" || travel_option == "outbound"
        ? individualPayload?.destinationCountry
        : "",
  });
  const defaultReason = {
    value: individualPayload?.reason ? individualPayload?.reason : "",
    label: individualPayload?.reason ? individualPayload?.reason : "",
  };

  const reasons: any = [
    { name: "BUSINESS", label: t("travelDetails.reasonBusiness") },
    { name: "TOURIST", label: t("travelDetails.reasonTourist") },
    { name: "STUDIES", label: t("travelDetails.reasonStudies") },
    { name: "MEDICAL", label: t("travelDetails.reasonMedical") },
  ];
  const [countries, setCountries] = useState<any[]>();

  const handleInputChange = (event: any) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setTravelInfo((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleInputInboundChange = (event: any) => {
    let destinations = [{ country: isStandard ? "Ethiopia" : "Kenya" }];
    setTravelInfo((prevState) => ({
      ...prevState,
      destinationCountry: destinations,
    }));
  };

  const handleChange = (selectedOption: any) => {
    setTravelInfo((previousState: any) => ({
      ...previousState,
      reason: selectedOption.name,
    }));
  };

  const handleCountriesChange = (selectedOption: any) => {
    let destination = selectedOption?.map((option) => {
      let destination = { ...option };
      destination["country"] = destination?.value;
      destination["town"] = "unknown";
      delete destination.value;
      delete destination.label;
      return destination;
    });
    setTravelInfo((previousState: any) => ({
      ...previousState,
      destinationCountry: destination,
    }));
  };

  const handleInboundCountriesChange = (selectedOption: any) => {
    setTravelInfo((previousState: any) => ({
      ...previousState,
      departureCountry: selectedOption.value,
    }));
  };

  const handleUserInforInputChange = (event: any) => {
    const { name, value } = event.target;
    setUserInfor((previousState) => ({ ...previousState, [name]: value }));
  };

  const saveDetails = () => {
    if (!travelInfo.startDate) {
      toast.warning("Enter Travelling date!");
      document.getElementById("startDate")?.focus;
      return;
    }
    if (!travelInfo.reason) {
      toast.warning("Please select a reason");
      document.getElementById("reason")?.focus;
      return;
    }
    if (!travelInfo.destinationCountry) {
      toast.warning("Enter Destination Country!");
      document.getElementById("destinationCountry")?.focus;
      return;
    }
    if (!travelInfo.departureCountry) {
      toast.warning("Enter Departure Country!");
      document.getElementById("departureCountry")?.focus;
      return;
    }
    if (!travelInfo.yearOfBirth) {
      toast.warning("Enter Date of Birth!");
      document.getElementById("yearOfBirth")?.focus;
      return;
    }
    if (!travelInfo.endDate) {
      toast.warning("Enter a valid end date");
      document.getElementById("endDate")?.focus;
      return;
    }
    let endDate = new Date(travelInfo.endDate);
    let startDate = new Date(travelInfo.startDate);
    if (endDate < startDate) {
      toast.warning("Please select a valid end date");
      return;
    }

    let date = travelInfo.startDate.replaceAll("-", "/");
    let travelDate = date.split("/").reverse().join("/");

    let travelAddedendDate = travelInfo.endDate.replaceAll("-", "/");
    let travelendDate = travelAddedendDate.split("/").reverse().join("/");

    sessionStorage.setItem("startDate", travelDate);
    sessionStorage.setItem("endDate", travelendDate);
    sessionStorage.setItem("travelInfo", JSON.stringify(travelInfo));
    sessionStorage.setItem("travel_type", "Individual");
    proceedUserDetails();

    if (dispatch(stepActions.onAddStep())) {
      nextStep();
      dispatch(getIndividualPayloadActions.setIndividualPayload(travelInfo));
    }
  };

  const proceedUserDetails = () => {
    if (!userInfor.userName) {
      toast.warning("Enter name");
      document.getElementById("userName")?.focus;
      return;
    }
    if (!onValidEmailAddress(userInfor.email)) {
      document.getElementById("email")?.focus();
      toast.warning("Email Address required or invalid");
      return;
    }
    if (!onValidatePhoneNumber(userInfor.phoneNumber)) {
      toast.warning("Phone number required or invalid");
      document.getElementById("phoneNumber")?.focus();
      return;
    }

    mixpanelIdentify({
      email: userInfor.email,
      phoneNumber: userInfor.phoneNumber,
      userName: userInfor.userName,
      feduid: "",
    });
  };

  const getCountries = async () => {
    const result: IApiResponse = await makeGetRequest(
      `${process.env.REACT_APP_TRAVEL_API_URL}/countries`
    );
    if (result.Status == 200) {
      let countries: any[] = result.Payload;
      countries.map((country) => {
        country["value"] = country?.name;
        delete country?.name;
        return country;
      });
      setCountries(countries);
    } else {
      toast.warning(result.Payload);
    }
  };

  const getTravellingOption = (): string => {
    if (travel_option == "inbound" || travel_option == "outbound") {
      return "country";
    }
    return "town";
  };

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const getMinimumBirthDate = () => {
    const today = new Date();
    today.setFullYear(today.getFullYear() - 18);
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const setIndividualScreen = () => {
    setCurrentScreen("individual");
    dispatch(travelCurrentScreenActions.setCurrentScreen("individual"));
  };

  const setGroupScreen = () => {
    setCurrentScreen("group");
    dispatch(travelCurrentScreenActions.setCurrentScreen("group"));
  };

  const setFamilyScreen = () => {
    setCurrentScreen("family");
    dispatch(travelCurrentScreenActions.setCurrentScreen("family"));
  };

  const initializeInbound = () => {
    if (travel_option == "inbound") {
      let destinations = [{ country: isStandard ? "Ethiopia" : "Kenya", town: "unknown" }];
      setTravelInfo((prevState) => ({
        ...prevState,
        destinationCountry: destinations,
      }));
    }
  };

  useEffect(() => {
    getCountries();
    initializeInbound();
  }, []);

  return (
    <motion.div variants={variants} initial="enter" animate="center">
      <div className="container mb-3">
        <div className="row d-flex justify-content-between align-items-center">
          <div className="col-md-5">
            <div className="ky-input-wrapper">
              <motion.div
                animate={{ scale: [-0.7, 1] }}
                transition={{ duration: 1 }}
                className="ky-input-container mt-4"
              >
                <label className="text-left-label mb-2" htmlFor="coverType">
                  {t("travelDetails.typeOfCover")}
                </label>
                <br />
                <div className="family-type-selection">
                  <div className="individual" onClick={(e) => { e.preventDefault(); setIndividualScreen(); }}>
                    <input
                      id="coverType"
                      name="coverType"
                      type="radio"
                      checked={individualStatus}
                      onChange={handleInputChange}
                      value={"individual"}
                    />
                    <span className="ky-individual">{t("travelDetails.individual")}</span>
                  </div>
                  <div className="group" onClick={(e) => { e.preventDefault(); setGroupScreen(); }}>
                    <input
                      id="coverType"
                      name="coverType"
                      type="radio"
                      checked={groupStatus}
                      onChange={handleInputChange}
                      value={travelInfo.startDate}
                    />
                    <span className="ky-group">{t("travelDetails.group")}</span>
                  </div>
                  {travel_option == "outbound" && (
                    <div className="group" onClick={(e) => { e.preventDefault(); setFamilyScreen(); }}>
                      <input
                        id="coverType"
                        name="coverType"
                        type="radio"
                        checked={groupStatus}
                        onChange={handleInputChange}
                        value={travelInfo.startDate}
                      />
                      <span className="ky-group">{t("travelDetails.family")}</span>
                    </div>
                  )}
                </div>
              </motion.div>
            </div>
          </div>
          <div className="col-md-5">
            <div className="ky-input-wrapper">
              <motion.div
                animate={{ scale: [-0.7, 1] }}
                transition={{ duration: 1 }}
                className="ky-input-container mt-4"
              >
                <label className="text-left-label mb-2" htmlFor="startDate">
                  {t("travelDetails.whenTravelling")}
                </label>
                <br />
                <input
                  id="startDate"
                  name="startDate"
                  type="date"
                  onChange={handleInputChange}
                  value={travelInfo.startDate}
                  min={getCurrentDate()}
                />
              </motion.div>
            </div>
          </div>
        </div>

        <div className="row d-flex justify-content-between align-items-center">
          <div className="col-md-5">
            <div className="ky-input-wrapper">
              <motion.div
                animate={{ scale: [-0.7, 1] }}
                transition={{ duration: 1 }}
                className="ky-input-container mt-4"
              >
                <label className="text-left-label mb-2" htmlFor="reason">
                  {t("travelDetails.reason")}
                </label>
                <br />
                <Select
                  options={reasons}
                  onChange={handleChange}
                  id={"destinationCountry"}
                  className={"destinationCountry"}
                  defaultValue={defaultReason}
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      backgroundColor: "#F6F8FB",
                      border: state.isFocused ? "none" : "#F6F8FB",
                    }),
                    input: (baseStyles) => ({
                      ...baseStyles,
                      width: "315px",
                      height: "47px",
                    }),
                    dropdownIndicator: (baseStyles) => ({
                      ...baseStyles,
                      color: "#00000",
                      fontWeight: "bold",
                    }),
                    container: (baseStyles) => ({
                      ...baseStyles,
                      border: "none",
                    }),
                  }}
                />
              </motion.div>
            </div>
          </div>
          <div className="col-md-5">
            <div className="ky-input-wrapper">
              <motion.div
                animate={{ scale: [-0.7, 1] }}
                transition={{ duration: 1 }}
                className="ky-input-container mt-4"
              >
                <label className="text-left-label mb-2" htmlFor="endDate">
                  {t("travelDetails.whenComingBack")}
                </label>
                <br />
                <input
                  id="endDate"
                  name="endDate"
                  type="date"
                  onChange={handleInputChange}
                  value={travelInfo.endDate}
                  min={getCurrentDate()}
                />
              </motion.div>
            </div>
          </div>
        </div>

        <div className="row d-flex justify-content-between align-items-center">
          <div className="col-md-5">
            <div className="ky-input-wrapper">
              <motion.div
                animate={{ scale: [-0.7, 1] }}
                transition={{ duration: 1 }}
                className="ky-input-container mt-4"
              >
                <label className="text-left-label mb-2" htmlFor="yearOfBirth">
                  {t("travelDetails.birthDate")}
                </label>
                <br />
                <input
                  id="yearOfBirth"
                  name="yearOfBirth"
                  type="date"
                  onChange={handleInputChange}
                  value={travelInfo.yearOfBirth}
                  max={getMinimumBirthDate()}
                />
              </motion.div>
            </div>
          </div>
          <div className="col-md-5">
            {(travel_option == "outbound" || travel_option == "town") && (
              <div className="ky-input-wrapper">
                <motion.div
                  animate={{ scale: [-0.7, 1] }}
                  transition={{ duration: 1 }}
                  className={
                    getTravellingOption() !== "town"
                      ? "ky-input-container mt-4 country-travel"
                      : "ky-input-container mt-4"
                  }
                >
                  <label className="text-left-label mb-2" htmlFor="departureCountry">
                    {t("travelDetails.departure", { option: getTravellingOption() })}
                  </label>
                  <br />
                  <input
                    id="departureCountry"
                    name="departureCountry"
                    type="text"
                    className={getTravellingOption() !== "town" ? "country-travel" : ""}
                    onChange={handleInputChange}
                    value={travelInfo.departureCountry}
                    placeholder={t("travelDetails.typeLocation")}
                  />
                </motion.div>
              </div>
            )}
            {travel_option == "inbound" && (
              <div className="ky-input-wrapper">
                <motion.div
                  animate={{ scale: [-0.7, 1] }}
                  transition={{ duration: 1 }}
                  className="ky-input-container mt-4"
                >
                  <label className="text-left-label mb-2" htmlFor="reason">
                    {t("travelDetails.departure", { option: getTravellingOption() })}
                  </label>
                  <br />
                  <Select
                    closeMenuOnSelect={false}
                    components={animatedComponents}
                    options={countries}
                    onChange={handleInboundCountriesChange}
                    id={"destinationCountry"}
                    className={"destinationCountry"}
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        backgroundColor: "#F6F8FB",
                        border: state.isFocused ? "none" : "#F6F8FB",
                      }),
                      dropdownIndicator: (baseStyles) => ({
                        ...baseStyles,
                        color: "#00000",
                        fontWeight: "bold",
                      }),
                      container: (baseStyles) => ({
                        ...baseStyles,
                        border: "none",
                      }),
                    }}
                  />
                </motion.div>
              </div>
            )}
          </div>
        </div>

        <div className="row d-flex justify-content-between align-items-center">
          {getTravellingOption() !== "town" && (
            <>
              {travel_option == "outbound" && (
                <div className="col-md-5">
                  <div className="ky-input-wrapper">
                    <motion.div
                      animate={{ scale: [-0.7, 1] }}
                      transition={{ duration: 1 }}
                      className="ky-input-container mt-4"
                    >
                      <label className="text-left-label mb-2" htmlFor="reason">
                        {t("travelDetails.arrival", { option: "country" })}
                      </label>
                      <br />
                      <Select
                        closeMenuOnSelect={false}
                        components={animatedComponents}
                        isMulti
                        options={countries}
                        onChange={handleCountriesChange}
                        id={"destinationCountry"}
                        className={"destinationCountry"}
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            backgroundColor: "#F6F8FB",
                            border: state.isFocused ? "none" : "#F6F8FB",
                          }),
                          dropdownIndicator: (baseStyles) => ({
                            ...baseStyles,
                            color: "#00000",
                            fontWeight: "bold",
                          }),
                          container: (baseStyles) => ({
                            ...baseStyles,
                            border: "none",
                          }),
                        }}
                      />
                    </motion.div>
                  </div>
                </div>
              )}
              {travel_option == "inbound" && (
                <div className="col-md-5">
                  <div className="ky-input-wrapper">
                    <motion.div
                      animate={{ scale: [-0.7, 1] }}
                      transition={{ duration: 1 }}
                      className="ky-input-container mt-4 country-travel"
                    >
                      <label className="text-left-label mb-2" htmlFor="destinationCountry">
                        {t("travelDetails.arrival", { option: "country" })}
                      </label>
                      <br />
                      <input
                        id="destinationCountry"
                        name="destinationCountry"
                        type="text"
                        className="country-travel"
                        onChange={handleInputInboundChange}
                        value={isStandard ? "Ethiopia" : "Kenya"}
                        placeholder={t("travelDetails.typeLocation")}
                      />
                    </motion.div>
                  </div>
                </div>
              )}
            </>
          )}
          {travel_option == "town" && (
            <div className="col-md-5">
              <div className="ky-input-wrapper">
                <motion.div
                  animate={{ scale: [-0.7, 1] }}
                  transition={{ duration: 1 }}
                  className="ky-input-container mt-4"
                >
                  <label className="text-left-label mb-2" htmlFor="destinationCountry">
                    {t("travelDetails.arrival", { option: travel_option })}
                  </label>
                  <br />
                  <input
                    id="destinationCountry"
                    name="destinationCountry"
                    type="text"
                    onChange={handleInputChange}
                    value={travelInfo.destinationCountry}
                    placeholder={t("travelDetails.typeLocation")}
                  />
                </motion.div>
              </div>
            </div>
          )}
        </div>

        {/* ✅ User info fields — no duplicate destination country block here */}
        <div className="row d-flex justify-content-between align-items-center">
          <div className="col-md-5">
            <div className="ky-input-wrapper">
              <motion.div
                animate={{ scale: [-0.7, 1] }}
                transition={{ duration: 1 }}
                className="ky-input-container mt-4"
              >
                <label className="text-left-label mb-2" htmlFor="userName">
                  {t("travelDetails.yourName")}
                </label>
                <br />
                <input
                  id="userName"
                  name="userName"
                  type="text"
                  value={userInfor.userName}
                  onChange={handleUserInforInputChange}
                  placeholder={t("travelDetails.typeName")}
                />
              </motion.div>
            </div>
          </div>
          <div className="col-md-5">
            <div className="ky-input-wrapper">
              <motion.div
                animate={{ scale: [-0.7, 1] }}
                transition={{ duration: 1 }}
                className="ky-input-container mt-4"
              >
                <label className="text-left-label mb-2" htmlFor="phoneNumber">
                  {t("travelDetails.yourPhone")}
                </label>
                <br />
                <input
                  id="phoneNumber"
                  name="phoneNumber"
                  type="text"
                  value={userInfor.phoneNumber}
                  onChange={handleUserInforInputChange}
                  placeholder={t("travelDetails.typePhone")}
                />
              </motion.div>
            </div>
          </div>
          <div className="col-md-5">
            <div className="ky-input-wrapper">
              <motion.div
                animate={{ scale: [-0.7, 1] }}
                transition={{ duration: 1 }}
                className="ky-input-container mt-4"
              >
                <label className="text-left-label mb-2" htmlFor="email">
                  {t("travelDetails.yourEmail")}
                </label>
                <br />
                <input
                  id="email"
                  name="email"
                  type="email"
                  onChange={handleUserInforInputChange}
                  value={userInfor.email}
                  placeholder={t("travelDetails.typeEmail")}
                />
              </motion.div>
            </div>
          </div>
        </div>
      </div>

      <div className="ky-inputs-container-1">
        <div className="mt-2 pointer-button">
          <div className="previous">
            <span onClick={() => { dispatch(stepActions.onRemoveStep()); previousStep(); }}>
              <span className="GrIcon me-2"><GrIcons.GrFormPreviousLink /></span>
              <span className="previous">{t("travelDetails.previous")}</span>
            </span>
          </div>
          <button className="next-btn" onClick={() => saveDetails()}>
            <span>{t("travelDetails.next")} <span className="GrIcon ms-3"><GrIcons.GrFormNextLink /></span></span>
          </button>
        </div>
      </div>
    </motion.div>
  );
}

export default IndividualDetails;